import { useEffect, useState } from 'react';
import { Divider, Descriptions, Input, Select, Space, Radio, Flex, Checkbox } from 'antd';
import { BaseContainer } from 'components/containers';
import { Editor, OutlinedButton, EditButton, DataGrid, DeleteButton } from 'components/elements';
import { BaseSection } from 'components/layouts';
import { objToLowerCase } from 'utils/utils';
import { putBoardClassAPI, getBoardClassCategoryAPI, getBoardClassDetailAPI } from 'api/board';
import { Attachment, Upload } from 'pages/common';
import { IconPaperClip } from 'components/assets/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { URL_ADMIN } from 'routes/AdminRoute';
import { URL_BOARD_CLASS_DETAIL } from 'routes/CommonRoute';
import { CloseSquareOutlined } from '@ant-design/icons';

export default function BoardClassEdit() {
  const navigate = useNavigate();
  const { no } = useParams();

  const [value, setValue] = useState({});
  const [cate, setCate] = useState([]);
  const [cate2, setCate2] = useState([]);
  const [loading, setLoading] = useState(false)

  const fnUpload = (v) => {
    const fileName = []
    const filePath = []
    v?.map(it => {
      if (it?.file_path) {
        fileName.push(it?.origin_file_name)
        filePath.push(it?.file_path)
      }
    })
    setValue({
      ...value,
      addFileName: fileName,
      addFilePath: filePath
    })
  }

  const fnChangeOptions = (e) => {
    setValue({ ...value, ...e });
  };

  const fnUpadte = async () => {
    setLoading(true)
    try {
      const body = {
        ...value,
        FILE_LIST: {
          ...value?.FILE_LIST,
          ATTACHED_FILE: value?.addFileName ? (value?.FILE_LIST?.ATTACHED_FILE || []).concat(value?.addFileName) : value?.FILE_LIST?.ATTACHED_FILE,
          ATTACHED_FILE_PATH: value?.addFilePath ? (value?.FILE_LIST?.ATTACHED_FILE_PATH || []).concat(value?.addFilePath) : value?.FILE_LIST?.ATTACHED_FILE_PATH
        }
      };
      delete body.addFileName;
      delete body.addFilePath;
      
      await putBoardClassAPI(objToLowerCase(body))
      alert('수정되었습니다.');
      navigate(`${URL_ADMIN}${URL_BOARD_CLASS_DETAIL.replace(':no', no)}`)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  };

  //수업자료 카테고리 1차,2차 목록
  const fnGetBoardClassCategory = async (params) => {
    try {
      const { data } = await getBoardClassCategoryAPI(params)
      const { data_list } = data
      params ? setCate2(data_list?.map((it) => ({ label: it?.BOOK_CATE2, value: it?.BOOK_CATE2_CODE }))) : setCate(data_list?.map((it) => ({ label: it?.BOOK_CATE1, value: it?.BOOK_CATE1_CODE })))
    } catch (err) {
      console.error(err)
    }
  };

  const fnGetDetail = async () => {
    await getBoardClassDetailAPI(no)
    .then(res => {
      setValue(res?.data?.data_info)
    })
    .catch(err => {
      console.error(err)
    })
  }

  useEffect(() => {
    fnGetBoardClassCategory();
    fnGetDetail()
  }, [no]);

  useEffect(() => {
    if (value?.BOARD_CLASS_CATE1_CODE) {
      const params = {
        board_class_cate1_code: value?.BOARD_CLASS_CATE1_CODE
      }
      fnGetBoardClassCategory(params)
    }
  }, [value?.BOARD_CLASS_CATE1_CODE])

  const fileColumns = [
    {
      key: '1',
      title: '',
      dataIndex: 'ATTACHED_FILE',
      render: (text, record) => (
        <>
          {record?.FILE_LIST?.ATTACHED_FILE_PATH && (
            <Space direction={'vertical'} size={0}>
              {record?.FILE_LIST?.ATTACHED_FILE_PATH?.map((item, index) => (
                <Space>
                  <Attachment key={index} label={`${record?.FILE_LIST?.ATTACHED_FILE?.[index]}`} icon={<IconPaperClip />} url={item} maxLength={100} />
                  <CloseSquareOutlined onClick={()=> {
                    let attached_file=[]
                    let attached_file_path =[];
                    attached_file = record?.FILE_LIST?.ATTACHED_FILE?.filter((it,i)=>i!=index)
                    attached_file_path = record?.FILE_LIST?.ATTACHED_FILE_PATH?.filter((it,i)=>i!=index)
                    fnChangeOptions({FILE_LIST: {
                      ATTACHED_FILE:attached_file,
                      ATTACHED_FILE_PATH: attached_file_path
                      }
                    })
                    } }/>
                </Space>
              ))}
            </Space>
          )}
        </>
      )
    },
  ];

  const items1 = [
    { key: '1', span: 2, label: '문서번호', children: value?.IDX },
    {
      key: '2',
      label: <span className='text-require'>노출여부</span>,
      children: (
        <Radio.Group
          onChange={(e) => {
            fnChangeOptions({ READ_AUTHORITY: e.target.value });
          }}
          value={value?.READ_AUTHORITY}
        >
          <Radio value={'1'}>노출</Radio>
          <Radio value={'3'}>비노출</Radio>
        </Radio.Group>
      )
    },
    { key: '3', label: '상단고정',
      children: <Checkbox checked={value?.FIXING_TOP_YN} onChange={(e) => setValue({ ...value, FIXING_TOP_YN: e.target.checked ? 1 : 0 })} />
    },
    {
      key: '4',
      span: 2,
      label: <span className='text-require'>카테고리</span>,
      children: (
        <Space>
          <Select
            value={value?.BOARD_CLASS_CATE1_CODE}
            style={{ width: '20rem' }}
            options={cate}
            onSelect={(e) => {
              if (e !== value?.BOARD_CLASS_CATE1_CODE) {
                fnChangeOptions({ BOARD_CLASS_CATE1_CODE: e, BOARD_CLASS_CATE2_CODE: null }); 
              }
            }}
          />
          <Select
            placeholder={'선택하세요'}
            value={value?.BOARD_CLASS_CATE2_CODE}
            style={{ width: '20rem' }}
            options={cate2}
            onSelect={(e) => {
              if (e !== value?.BOARD_CLASS_CATE2_CODE) {
                fnChangeOptions({ BOARD_CLASS_CATE2_CODE: e })
              }
            }}
          />
        </Space>
      )
    },
    {
      key: '5',
      span: 2,
      label: <span className='text-require'>제목</span>,
      children: <Input value={value?.TITLE} onChange={(e) => setValue({ ...value, TITLE: e.target.value })} />
    },
    {
      key: '6',
      label: '첨부파일',
      children: (
        <Flex vertical={true} gap="4px">
          {value?.FILE_LIST?.ATTACHED_FILE_PATH && <DataGrid showHeader={false} bordered={false} columns={fileColumns} data={[value]} />}
          <Upload inputSize={'300px'} data={[]} onChange={fnUpload} />
        </Flex>
      )
    }
  ];

  return (
    <BaseSection>
      <BaseContainer>
        <Descriptions bordered column={2} labelStyle={{ width: '16rem' }} contentStyle={{ textAlign: 'left', width: '65rem' }} items={items1} />
        <Divider className="divider-small" />
        
        <Editor data={value?.CONTENT} onChange={(v) => setValue({ ...value, CONTENT: v })} />
        <Divider className="divider" />

        <Flex justify="flex-end" gap={3}>
          <EditButton loading={loading} label={'수정하기'} onClick={fnUpadte} />
          <OutlinedButton label="목록" color={'var(--color-gray03)'} onClick={() => navigate(`${URL_ADMIN}${URL_BOARD_CLASS_DETAIL.replace(':no', no)}`)} />
        </Flex>
      </BaseContainer>
    </BaseSection>
  );
}
